import { render, staticRenderFns } from "./ImagePickerUpload.vue?vue&type=template&id=53189744&scoped=true&"
import script from "./ImagePickerUpload.vue?vue&type=script&lang=js&"
export * from "./ImagePickerUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImagePickerUpload.vue?vue&type=style&index=0&id=53189744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53189744",
  null
  
)

export default component.exports